import * as React from 'react';
import { Button, Box, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import LikeAction from '../LikeAction';
import LinkToListDialog from '../../../../components/shared/Dialog/LinkToListDialog';
import RatingAction from '../RatingAction/RatingAction';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const CafeActionsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '10px',
  marginLeft: '-4px',
  [theme.breakpoints.down('850')]: {
    paddingBottom: '5px',
    paddingLeft: '53px',
  },
  [theme.breakpoints.down('450')]: {
    paddingBottom: '5px',
    paddingLeft: '10px',
  },
  [theme.breakpoints.down('370')]: {
    paddingBottom: '5px',
    paddingLeft: '5px',
  },
}));

const NoteTypography = styled(Typography)(() => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '14px',
  lineHeight: '21px',
  display: 'flex',
  alignItems: 'center',
  color: '#000000',
  gap: '2px',
}));

const ViewsButton = styled(Button)(() => ({
  margin: 0,
  padding: 0,
  display: 'flex',
  color: '#000000',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  textTransform: 'none',
}));

const ButtonNumberLabel = styled('span')(() => ({
  marginLeft: '5px',
  fontWeight: '600',
}));

const ButtonLabel = styled('span')(() => ({
  fontFamily: 'Raleway',
  marginLeft: '3px',
  fontWeight: '400',
}));

const ItemNumber = styled('span')({
  lineHeight: '27px',
  fontFamily: 'Poppins',
  fontWeight: 'bold',
  paddingRight: '5px',
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const FirstActionPartButton = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: '10px',
  marginLeft: '-4px',
  [theme.breakpoints.down('850')]: {
    flexDirection: 'column',
    gap: '8px',
    marginLeft: '60px',
    marginRight: '8px',
    width: '20%',
  },
  [theme.breakpoints.down('450')]: {
    flexDirection: 'column',
    gap: '7px',
    marginLeft: '58px',
    width: '20%',
  },
  [theme.breakpoints.down('370')]: {
    flexDirection: 'column',
    gap: '7px',
    marginLeft: '54px',
    width: '20%',
  },
}));

const SecondActionPartButton = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: '10px',
  marginRight: '100px',
  marginBottom: '1px',
  [theme.breakpoints.down('850')]: {
    flexDirection: 'column',
    gap: '8px',
    marginLeft: '30px',
    marginBottom: '1px',
    width: '20%',
  },
  [theme.breakpoints.down('450')]: {
    flexDirection: 'column',
    gap: '7px',
    marginLeft: '10px',
    marginBottom: '1px',
    width: '20%',
  },
}));

export const ActionGroup = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <ViewsButton onClick={handleOpen}>
        {props.optionIcon}
        <ButtonNumberLabel>{props.number}</ButtonNumberLabel>
        <ButtonLabel>{props.label}</ButtonLabel>
      </ViewsButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Text in a modal
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Hello,Welcome to CoffeeTopia.
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
};

const CafeReviews = ({ cafeData, currentUser }) => {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  return (
    <CafeActionsContainer>
      <FirstActionPartButton>
        <RatingAction cafeData={cafeData} currentId={currentUser} isLogin={isLogin} />
        <LikeAction cafeData={cafeData} currentId={currentUser} isLogin={isLogin} />
      </FirstActionPartButton>

      <SecondActionPartButton>
        <NoteTypography>
          <ImportContactsOutlinedIcon style={{ color: '#AB9178' }} />
          <ButtonNumberLabel>{cafeData.relatedNotes.length}</ButtonNumberLabel>
          <ButtonLabel>notes</ButtonLabel>
        </NoteTypography>

        <LinkToListDialog title="followers" userList={cafeData.followedUsers}>
          <SentimentSatisfiedAltIcon style={{ color: '#AB9178', marginRight: '5px' }} />
          <ItemNumber>{cafeData.followedUsers.length} </ItemNumber>
          followers
        </LinkToListDialog>
      </SecondActionPartButton>
    </CafeActionsContainer>
  );
};
export default CafeReviews;
